if (!customElements.get('product-description-collapsible')) {
  customElements.define(
    'product-description-collapsible',
    class ProductDescriptionCollapsible extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.product-description-collapsible__content');
        this.toggle = this.querySelector('.product-description-collapsible__toggle');
        this.toggleText = this.querySelector('.product-description-collapsible__toggle-text');
        this.onToggle = this.onToggle.bind(this);
        this.evaluate = this.evaluate.bind(this);
      }

      connectedCallback() {
        if (!this.content || !this.toggle) return;
        this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10) || 160;

        this.toggle.addEventListener('click', this.onToggle);
        window.addEventListener('resize', this.evaluate);

        // Re-check once images inside the description have loaded (they change height).
        this.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', this.evaluate, { once: true });
        });

        this.evaluate();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.evaluate);
      }

      // Decide whether the description is long enough to need collapsing.
      evaluate() {
        const fullHeight = this.content.scrollHeight;
        const overflows = fullHeight > this.collapsedHeight + 8;

        if (!overflows) {
          this.classList.remove('is-collapsible', 'is-expanded');
          this.toggle.hidden = true;
          return;
        }

        this.toggle.hidden = false;
        this.content.style.setProperty('--pdc-full-height', `${fullHeight}px`);

        // Default to collapsed unless the user already expanded it.
        if (!this.classList.contains('is-expanded')) {
          this.classList.add('is-collapsible');
        }
      }

      onToggle() {
        const expanded = this.classList.toggle('is-expanded');
        this.classList.toggle('is-collapsible', !expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));

        if (this.toggleText) {
          const key = expanded ? 'textLess' : 'textMore';
          if (this.toggleText.dataset[key]) this.toggleText.textContent = this.toggleText.dataset[key];
        }
      }
    }
  );
}
